module.exports = __webpack_public_path__ + "static/img/setingu1.19352956.png";